export const getPlatformName = () => {
  const { appVersion, userAgent } = window.navigator;
  // Dectect iOS devices and camouflage IPad Pros that mock desktop browsers.
  const isIOS = /iPad|iPhone|iPod/.test(userAgent) || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);

  switch (true) {
    case isIOS:
      return 'ios';
    case /android/i.test(userAgent):
      return 'android';
    case appVersion.indexOf('Win') !== -1:
      return 'windows';
    case appVersion.indexOf('Mac') !== -1:
      return 'macos';
    case appVersion.indexOf('X11') !== -1:
      return 'unix';
    case appVersion.indexOf('Linux') !== -1:
      return 'linux';
    default:
      return 'unknown os';
  }
};

export const isWindows = () => {
  return getPlatformName() === 'windows';
};

export const isOldIE = () => window.navigator.userAgent.match(/(MSIE|Trident)/);
